import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from '../../misc/Button';

import { BorderGrey } from '../../../constants/Colors';

const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledDescription = styled.div`
  margin-top: 2px;
  font-style: italic;
  font-size: 10px;
  color: ${BorderGrey};
  text-align: center;
`;

const ButtonSettings = ({
  fieldId,
  label,
  value,
  description,
  color,
  disabled,
  onChange
}) => {

  return (
    <>
      <StyledInputWrapper>
        <Button
          styles={{ flex: 1, borderColor: color, color }}
          text={label}
          disabled={disabled}
          onClick={() => {
            onChange(fieldId, value ? null : value);
          }}
        />
      </StyledInputWrapper>
      {!description ? null : <StyledDescription>{description}</StyledDescription>}
    </>
  );

};

ButtonSettings.propTypes = {
  fieldId: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  description: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ButtonSettings;
